// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-reportes {
  min-height: 100vh;
  padding: 32px 24px 40px;
  background:
    radial-gradient(circle at top right, rgba(0, 102, 153, 0.18), transparent 22%),
    linear-gradient(180deg, #eef5fb 0%, #f7fafc 40%, #ffffff 100%);
  color: #0f2f47;
}

.public-reportes__hero,
.public-reportes__status-card,
.public-reportes__contracts-panel,
.public-reportes__content-panel,
.public-reportes__viewer-shell,
.public-reportes__report-card,
.public-reportes__contract-card {
  border: 1px solid rgba(86, 106, 127, 0.16);
  box-shadow: 0 18px 35px rgba(14, 45, 70, 0.08);
}

.public-reportes__hero {
  max-width: 1440px;
  margin: 0 auto 24px;
  padding: 28px 30px;
  border-radius: 28px;
  background: linear-gradient(135deg, #063a5b 0%, #0b5f91 58%, #2f90c1 100%);
  color: #fff;
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: flex-end;
}

.public-reportes__eyebrow,
.public-reportes__viewer-kicker,
.public-reportes__report-category {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 0.72rem;
  font-weight: 800;
}

.public-reportes__eyebrow {
  padding: 8px 12px;
  margin-bottom: 14px;
  color: #d9f1ff;
  background: rgba(255, 255, 255, 0.12);
}

.public-reportes__hero h1 {
  margin: 0 0 10px;
  font-size: clamp(2rem, 3vw, 3rem);
  line-height: 1.05;
}

.public-reportes__hero p {
  margin: 0;
  max-width: 760px;
  color: rgba(255, 255, 255, 0.86);
}

.public-reportes__preview-banner {
  margin-top: 16px;
  width: fit-content;
  max-width: 720px;
  padding: 10px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.14);
  color: #f4fbff;
  font-size: 0.92rem;
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.public-reportes__preview-banner--workspace {
  margin: 0 0 18px;
  max-width: 100%;
  width: 100%;
  background: linear-gradient(135deg, rgba(0, 102, 153, 0.1), rgba(77, 148, 199, 0.16));
  color: #0a4f79;
  border-color: rgba(0, 102, 153, 0.16);
}

.public-reportes__hero-badge {
  min-width: 170px;
  padding: 18px 20px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  text-align: center;
}

.public-reportes__hero-badge strong {
  display: block;
  font-size: 2.35rem;
  line-height: 1;
}

.public-reportes__hero-badge span {
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.95rem;
}

.public-reportes__layout {
  max-width: 1440px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(320px, 380px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.public-reportes__contracts-panel,
.public-reportes__content-panel,
.public-reportes__viewer-shell,
.public-reportes__status-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 24px;
}

.public-reportes__contracts-panel,
.public-reportes__content-panel {
  padding: 22px;
}

.public-reportes__contracts-panel {
  height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.public-reportes__content-panel {
  min-width: 0;
  height: 90vh;
  overflow: hidden;
}

.public-reportes__report-workspace {
  display: grid;
  grid-template-columns: minmax(320px, 380px) minmax(0, 1fr);
  gap: 22px;
  align-items: start;
  height: 100%;
  min-height: 0;
}

.public-reportes__report-sidebar {
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: auto;
  padding-right: 6px;
}

.public-reportes__panel-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.public-reportes__panel-head h2,
.public-reportes__viewer-header h3 {
  margin: 0;
  font-size: 1.35rem;
  color: #063a5b;
}

.public-reportes__panel-head span {
  color: #566a7f;
  font-size: 0.95rem;
}

.public-reportes__contracts-grid,
.public-reportes__reports-list {
  display: grid;
  gap: 14px;
}

.public-reportes__contracts-grid {
  overflow: auto;
  padding-right: 6px;
}

.public-reportes__contract-card,
.public-reportes__report-card {
  width: 100%;
  border-radius: 20px;
  background: #fff;
}

.public-reportes__contract-card {
  position: relative;
  display: block;
  padding: 0;
  border: 1px solid rgba(0, 102, 153, 0.1);
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  overflow: hidden;
}

.public-reportes__contract-card:hover,
.public-reportes__report-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 32px rgba(14, 45, 70, 0.12);
}

.public-reportes__contract-card.is-active,
.public-reportes__report-card.is-active {
  border-color: rgba(0, 102, 153, 0.42);
  box-shadow: 0 24px 36px rgba(0, 102, 153, 0.16);
}

.public-reportes__contract-accent {
  position: absolute;
  inset: 0 auto 0 0;
  width: 6px;
  background: linear-gradient(180deg, #0d8d26 0%, #36b24d 100%);
}

.public-reportes__contract-content {
  display: grid;
  gap: 6px;
  padding: 14px 14px 12px 16px;
  margin-left: 6px;
}

.public-reportes__contract-line {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  color: #566a7f;
  font-size: 0.95rem;
  line-height: 1.25;
}

.public-reportes__contract-line strong {
  color: #4f6478;
  font-size: 0.98rem;
  font-weight: 800;
}

.public-reportes__contract-line span {
  color: #5f7388;
}

.public-reportes__contract-line--wrap {
  display: block;
}

.public-reportes__contract-line--wrap strong,
.public-reportes__contract-line--wrap span {
  display: inline;
}

.public-reportes__contract-inline-label {
  margin-left: 8px;
}

.public-reportes__contract-footer {
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.public-reportes__contract-footer small {
  color: #6c7f91;
  font-size: 0.9rem;
}

.public-reportes__contract-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.public-reportes__contract-mini {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.public-reportes__contract-mini--yellow {
  background: #ffd72f;
}

.public-reportes__contract-mini--blue {
  background: #58b7ff;
}

.public-reportes__contract-mini--green {
  background: #75d16d;
}

.public-reportes__contract-mini--gray {
  background: #d7dde3;
}

.public-reportes__contract-status {
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(0, 102, 153, 0.09);
  color: #006699;
  font-size: 0.8rem;
  font-weight: 700;
}

.public-reportes__report-card {
  padding: 18px;
  display: grid;
  gap: 14px;
}

.public-reportes__report-main {
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0;
  display: grid;
  gap: 8px;
}

.public-reportes__report-category {
  width: fit-content;
  padding: 6px 10px;
  color: #0a5e90;
  background: rgba(10, 94, 144, 0.09);
}

.public-reportes__report-main strong {
  font-size: 1.08rem;
  color: #063a5b;
}

.public-reportes__report-main p {
  margin: 0;
  color: #566a7f;
}

.public-reportes__report-actions,
.public-reportes__viewer-header {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.public-reportes__report-actions .btn,
.public-reportes__viewer-header .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.public-reportes__viewer-shell {
  overflow: hidden;
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.public-reportes__viewer-header {
  padding: 20px 22px 0;
}

.public-reportes__viewer-body {
  padding: 18px 22px 22px;
  min-width: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.public-reportes__consolidated-preview {
  width: 100%;
}

.public-reportes__consolidated-frame {
  width: 100%;
  height: 100%;
  overflow: auto;
  border-radius: 0;
  background: #fff;
  border: 0;
  box-shadow: none;
  padding: 0;
}

.public-reportes__preview-note {
  margin: 0 0 16px;
  padding: 12px 14px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(0, 102, 153, 0.1), rgba(77, 148, 199, 0.16));
  color: #0a4f79;
  border: 1px solid rgba(0, 102, 153, 0.16);
}

.public-reportes__empty-viewer,
.public-reportes__status-card {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
}

.public-reportes__empty-viewer {
  padding: 28px;
  border: 1px dashed rgba(86, 106, 127, 0.32);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(238, 245, 251, 0.8), rgba(255, 255, 255, 0.95));
  color: #566a7f;
}

.public-reportes__empty-viewer h4,
.public-reportes__status-card h3 {
  margin: 0;
  color: #063a5b;
}

.public-reportes__empty-viewer p,
.public-reportes__status-card p {
  margin: 0;
  max-width: 480px;
  color: #566a7f;
}

.public-reportes__status-card {
  max-width: 720px;
  margin: 80px auto;
  padding: 36px;
}

.public-reportes__status-card--error {
  background: linear-gradient(180deg, rgba(255, 245, 245, 0.95), rgba(255, 255, 255, 0.98));
}

@media (max-width: 1080px) {
  .public-reportes__layout {
    grid-template-columns: 1fr;
  }

  .public-reportes__report-workspace {
    grid-template-columns: 1fr;
  }

  .public-reportes__contracts-grid {
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  }

  .public-reportes__contracts-panel,
  .public-reportes__content-panel {
    height: auto;
    max-height: none;
  }

  .public-reportes__report-sidebar,
  .public-reportes__viewer-body,
  .public-reportes__contracts-grid {
    overflow: visible;
  }
}

@media (max-width: 768px) {
  .public-reportes {
    padding: 18px 14px 24px;
  }

  .public-reportes__hero,
  .public-reportes__contracts-panel,
  .public-reportes__content-panel {
    padding: 18px;
    border-radius: 22px;
  }

  .public-reportes__hero {
    flex-direction: column;
    align-items: stretch;
  }

  .public-reportes__hero-badge {
    width: 100%;
  }

  .public-reportes__contract-card {
    width: 100%;
  }

  .public-reportes__contract-status {
    grid-column: 1 / -1;
    width: fit-content;
  }

  .public-reportes__consolidated-frame {
    min-height: 62vh;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/publicReportes.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB;;kEAEgE;EAChE,cAAc;AAChB;;AAEA;;;;;;;EAOE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qFAAqF;EACrF,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;EAIE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qFAAqF;EACrF,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,wFAAwF;EACxF,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;IAGE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[".public-reportes {\n  min-height: 100vh;\n  padding: 32px 24px 40px;\n  background:\n    radial-gradient(circle at top right, rgba(0, 102, 153, 0.18), transparent 22%),\n    linear-gradient(180deg, #eef5fb 0%, #f7fafc 40%, #ffffff 100%);\n  color: #0f2f47;\n}\n\n.public-reportes__hero,\n.public-reportes__status-card,\n.public-reportes__contracts-panel,\n.public-reportes__content-panel,\n.public-reportes__viewer-shell,\n.public-reportes__report-card,\n.public-reportes__contract-card {\n  border: 1px solid rgba(86, 106, 127, 0.16);\n  box-shadow: 0 18px 35px rgba(14, 45, 70, 0.08);\n}\n\n.public-reportes__hero {\n  max-width: 1440px;\n  margin: 0 auto 24px;\n  padding: 28px 30px;\n  border-radius: 28px;\n  background: linear-gradient(135deg, #063a5b 0%, #0b5f91 58%, #2f90c1 100%);\n  color: #fff;\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n  align-items: flex-end;\n}\n\n.public-reportes__eyebrow,\n.public-reportes__viewer-kicker,\n.public-reportes__report-category {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n.public-reportes__eyebrow {\n  padding: 8px 12px;\n  margin-bottom: 14px;\n  color: #d9f1ff;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.public-reportes__hero h1 {\n  margin: 0 0 10px;\n  font-size: clamp(2rem, 3vw, 3rem);\n  line-height: 1.05;\n}\n\n.public-reportes__hero p {\n  margin: 0;\n  max-width: 760px;\n  color: rgba(255, 255, 255, 0.86);\n}\n\n.public-reportes__preview-banner {\n  margin-top: 16px;\n  width: fit-content;\n  max-width: 720px;\n  padding: 10px 14px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #f4fbff;\n  font-size: 0.92rem;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n}\n\n.public-reportes__preview-banner--workspace {\n  margin: 0 0 18px;\n  max-width: 100%;\n  width: 100%;\n  background: linear-gradient(135deg, rgba(0, 102, 153, 0.1), rgba(77, 148, 199, 0.16));\n  color: #0a4f79;\n  border-color: rgba(0, 102, 153, 0.16);\n}\n\n.public-reportes__hero-badge {\n  min-width: 170px;\n  padding: 18px 20px;\n  border-radius: 22px;\n  background: rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(8px);\n  text-align: center;\n}\n\n.public-reportes__hero-badge strong {\n  display: block;\n  font-size: 2.35rem;\n  line-height: 1;\n}\n\n.public-reportes__hero-badge span {\n  color: rgba(255, 255, 255, 0.84);\n  font-size: 0.95rem;\n}\n\n.public-reportes__layout {\n  max-width: 1440px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(320px, 380px) minmax(0, 1fr);\n  gap: 24px;\n  align-items: start;\n}\n\n.public-reportes__contracts-panel,\n.public-reportes__content-panel,\n.public-reportes__viewer-shell,\n.public-reportes__status-card {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  border-radius: 24px;\n}\n\n.public-reportes__contracts-panel,\n.public-reportes__content-panel {\n  padding: 22px;\n}\n\n.public-reportes__contracts-panel {\n  height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.public-reportes__content-panel {\n  min-width: 0;\n  height: 90vh;\n  overflow: hidden;\n}\n\n.public-reportes__report-workspace {\n  display: grid;\n  grid-template-columns: minmax(320px, 380px) minmax(0, 1fr);\n  gap: 22px;\n  align-items: start;\n  height: 100%;\n  min-height: 0;\n}\n\n.public-reportes__report-sidebar {\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  overflow: auto;\n  padding-right: 6px;\n}\n\n.public-reportes__panel-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n  margin-bottom: 18px;\n}\n\n.public-reportes__panel-head h2,\n.public-reportes__viewer-header h3 {\n  margin: 0;\n  font-size: 1.35rem;\n  color: #063a5b;\n}\n\n.public-reportes__panel-head span {\n  color: #566a7f;\n  font-size: 0.95rem;\n}\n\n.public-reportes__contracts-grid,\n.public-reportes__reports-list {\n  display: grid;\n  gap: 14px;\n}\n\n.public-reportes__contracts-grid {\n  overflow: auto;\n  padding-right: 6px;\n}\n\n.public-reportes__contract-card,\n.public-reportes__report-card {\n  width: 100%;\n  border-radius: 20px;\n  background: #fff;\n}\n\n.public-reportes__contract-card {\n  position: relative;\n  display: block;\n  padding: 0;\n  border: 1px solid rgba(0, 102, 153, 0.1);\n  text-align: left;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n  overflow: hidden;\n}\n\n.public-reportes__contract-card:hover,\n.public-reportes__report-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 22px 32px rgba(14, 45, 70, 0.12);\n}\n\n.public-reportes__contract-card.is-active,\n.public-reportes__report-card.is-active {\n  border-color: rgba(0, 102, 153, 0.42);\n  box-shadow: 0 24px 36px rgba(0, 102, 153, 0.16);\n}\n\n.public-reportes__contract-accent {\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 6px;\n  background: linear-gradient(180deg, #0d8d26 0%, #36b24d 100%);\n}\n\n.public-reportes__contract-content {\n  display: grid;\n  gap: 6px;\n  padding: 14px 14px 12px 16px;\n  margin-left: 6px;\n}\n\n.public-reportes__contract-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  color: #566a7f;\n  font-size: 0.95rem;\n  line-height: 1.25;\n}\n\n.public-reportes__contract-line strong {\n  color: #4f6478;\n  font-size: 0.98rem;\n  font-weight: 800;\n}\n\n.public-reportes__contract-line span {\n  color: #5f7388;\n}\n\n.public-reportes__contract-line--wrap {\n  display: block;\n}\n\n.public-reportes__contract-line--wrap strong,\n.public-reportes__contract-line--wrap span {\n  display: inline;\n}\n\n.public-reportes__contract-inline-label {\n  margin-left: 8px;\n}\n\n.public-reportes__contract-footer {\n  margin-top: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.public-reportes__contract-footer small {\n  color: #6c7f91;\n  font-size: 0.9rem;\n}\n\n.public-reportes__contract-icons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.public-reportes__contract-mini {\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  display: inline-block;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.public-reportes__contract-mini--yellow {\n  background: #ffd72f;\n}\n\n.public-reportes__contract-mini--blue {\n  background: #58b7ff;\n}\n\n.public-reportes__contract-mini--green {\n  background: #75d16d;\n}\n\n.public-reportes__contract-mini--gray {\n  background: #d7dde3;\n}\n\n.public-reportes__contract-status {\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(0, 102, 153, 0.09);\n  color: #006699;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.public-reportes__report-card {\n  padding: 18px;\n  display: grid;\n  gap: 14px;\n}\n\n.public-reportes__report-main {\n  border: 0;\n  background: transparent;\n  text-align: left;\n  padding: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.public-reportes__report-category {\n  width: fit-content;\n  padding: 6px 10px;\n  color: #0a5e90;\n  background: rgba(10, 94, 144, 0.09);\n}\n\n.public-reportes__report-main strong {\n  font-size: 1.08rem;\n  color: #063a5b;\n}\n\n.public-reportes__report-main p {\n  margin: 0;\n  color: #566a7f;\n}\n\n.public-reportes__report-actions,\n.public-reportes__viewer-header {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.public-reportes__report-actions .btn,\n.public-reportes__viewer-header .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.public-reportes__viewer-shell {\n  overflow: hidden;\n  min-height: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.public-reportes__viewer-header {\n  padding: 20px 22px 0;\n}\n\n.public-reportes__viewer-body {\n  padding: 18px 22px 22px;\n  min-width: 0;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n}\n\n.public-reportes__consolidated-preview {\n  width: 100%;\n}\n\n.public-reportes__consolidated-frame {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  border-radius: 0;\n  background: #fff;\n  border: 0;\n  box-shadow: none;\n  padding: 0;\n}\n\n.public-reportes__preview-note {\n  margin: 0 0 16px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, rgba(0, 102, 153, 0.1), rgba(77, 148, 199, 0.16));\n  color: #0a4f79;\n  border: 1px solid rgba(0, 102, 153, 0.16);\n}\n\n.public-reportes__empty-viewer,\n.public-reportes__status-card {\n  min-height: 280px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 10px;\n}\n\n.public-reportes__empty-viewer {\n  padding: 28px;\n  border: 1px dashed rgba(86, 106, 127, 0.32);\n  border-radius: 18px;\n  background: linear-gradient(180deg, rgba(238, 245, 251, 0.8), rgba(255, 255, 255, 0.95));\n  color: #566a7f;\n}\n\n.public-reportes__empty-viewer h4,\n.public-reportes__status-card h3 {\n  margin: 0;\n  color: #063a5b;\n}\n\n.public-reportes__empty-viewer p,\n.public-reportes__status-card p {\n  margin: 0;\n  max-width: 480px;\n  color: #566a7f;\n}\n\n.public-reportes__status-card {\n  max-width: 720px;\n  margin: 80px auto;\n  padding: 36px;\n}\n\n.public-reportes__status-card--error {\n  background: linear-gradient(180deg, rgba(255, 245, 245, 0.95), rgba(255, 255, 255, 0.98));\n}\n\n@media (max-width: 1080px) {\n  .public-reportes__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .public-reportes__report-workspace {\n    grid-template-columns: 1fr;\n  }\n\n  .public-reportes__contracts-grid {\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  }\n\n  .public-reportes__contracts-panel,\n  .public-reportes__content-panel {\n    height: auto;\n    max-height: none;\n  }\n\n  .public-reportes__report-sidebar,\n  .public-reportes__viewer-body,\n  .public-reportes__contracts-grid {\n    overflow: visible;\n  }\n}\n\n@media (max-width: 768px) {\n  .public-reportes {\n    padding: 18px 14px 24px;\n  }\n\n  .public-reportes__hero,\n  .public-reportes__contracts-panel,\n  .public-reportes__content-panel {\n    padding: 18px;\n    border-radius: 22px;\n  }\n\n  .public-reportes__hero {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .public-reportes__hero-badge {\n    width: 100%;\n  }\n\n  .public-reportes__contract-card {\n    width: 100%;\n  }\n\n  .public-reportes__contract-status {\n    grid-column: 1 / -1;\n    width: fit-content;\n  }\n\n  .public-reportes__consolidated-frame {\n    min-height: 62vh;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
